import React from 'react';
import { formatMoney } from '../../util/currency';

import css from './OrderBreakdown.module.css';

/**
 * Renders the retained deposit amount after dispute resolution.
 * Shows how much of the deposit the provider keeps for damages.
 */
const LineItemDepositRetainedMaybe = props => {
  const { lineItems, intl } = props;
  const item = lineItems.find(i => i.code === 'line-item/deposit-retained' && !i.reversal);

  if (!item) return null;

  const label = intl.formatMessage({ id: 'OrderBreakdown.depositRetained' });
  const formattedTotal = formatMoney(intl, item.lineTotal);

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>{label}</span>
      <span className={css.itemValue}>{formattedTotal}</span>
    </div>
  );
};

export default LineItemDepositRetainedMaybe;
